import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient";
import AthleteSidebar from "./athleteSidebar";
import CoachSidebar from "./coachSidebar";
import AdminSidebar from "./adminSidebar";
import SkillsTrainerSidebar from "./skillsTrainerSidebar";

export default function RoleSidebar({ user }) {
  const [role, setRole] = useState(null);

  useEffect(() => {
    if (!user) return;
    const fetchRole = async () => {
      const { data, error } = await supabase
        .from("users")
        .select("role")
        .eq("id", user.id)
        .single();

      if (!error && data) setRole(data.role);
    };
    fetchRole();
  }, [user]);

  if (!user) return null;
  if (!role) return null;

  switch (role) {
    case "Athlete":
      return <AthleteSidebar userId={user.id} />;
    case "Coach":
      return <CoachSidebar />;
    case "Administrator":
      return <AdminSidebar />;
    case "SkillsTrainer":
      return <SkillsTrainerSidebar />;
    default:
      return null;
  }
}
